(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServantByCompanyDialogController', ServantByCompanyDialogController);

    ServantByCompanyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Servant', 'PersonInfo', 'ServiceCategory', 'ServiceItem', 'PriceInfo', 'ActivityTypeInfoCustom', 'CompanyCustom'];

    function ServantByCompanyDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, Servant, PersonInfo, ServiceCategory, ServiceItem, PriceInfo, ActivityTypeInfoCustom, CompanyCustom) {
        var vm = this;
        vm.scope = $scope;
        vm.servant = entity;
        vm.clear = clear;
        vm.save = save;
        vm.isWorkSpace = false;

        loadData();

        function loadData() {
            CompanyCustom.getCurrentCompany().query(function (result) {
                ActivityTypeInfoCustom.getActivityTypeInfoByType(result.activityType).query(function (activity) {
                    vm.activityTypeInfo = activity;
                    if (activity && activity.servantType == "RESOURCE") {
                        vm.isWorkSpace = true;
                    }
                })
            });
        }


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            //
            if (vm.scope.editForm.$valid) {
                vm.isSaving = true;
                if (vm.servant.id !== null) {
                    Servant.update(vm.servant, onSaveSuccess, onSaveError);
                } else {
                    Servant.save(vm.servant, onSaveSuccess, onSaveError);
                }
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:servantUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
